import { AccredibleThemeableMultipleSearchInputComponentModule } from '@accredible-frontend-v2/forms/multiple-search-input';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SearchableSelectAnyInputComponent } from './searchable-select-any-input.component';

@NgModule({
  imports: [CommonModule, AccredibleThemeableMultipleSearchInputComponentModule],
  declarations: [SearchableSelectAnyInputComponent],
  exports: [SearchableSelectAnyInputComponent],
})
export class SearchableSelectAnyInputComponentModule {}
